export { Body2, body2ClassNames } from './components/presets/Body2/index';
